import { createTheme } from '@mui/material/styles';
import {
  pink,
  red,
  purple,
  deepPurple,
  indigo,
  blue,
  lightBlue,
  cyan,
  teal,
  green,
  lightGreen,
  lime,
  orange,
  amber,
  yellow,
  deepOrange,
  brown,
  grey,
  blueGrey,
} from '@mui/material/colors';

const theme = createTheme({
  typography: {
    fontFamily: "'Pretendard', 'Roboto', 'Helvetica', 'Arial', sans-serif",
  },
  palette: {
    // 기존
    primary: {
      light: '#008b43',
      main: '#008b43',
      dark: '#00b557',
      contrastText: '#fff',
    },
    secondary: {
      main: '#2196f3',
      light: '#63ccff',
      dark: '#0069c0',
      contrastText: '#fff',
    },

    // new색상
    brand: {
      main: '#2CA900',
    },
    background: {
      black: '#000000',
      white: '#ffffff',
      yellow: amber[500],
      gray: '#333333',
      tableCell: '#E4E8E9',
      home: '#f0f0f0',
      drawer: '#E6F7E0',
    },
    grid: {
      new: '#128191',
      error: '##FFE6E6',
      focus: blue[700],
      yellow: amber[500],
      required: '#fffdf5',
    },

    text: {
      main: '#000000',
      disabled: '#888888',
      error: red[500],
      success: green[500],
      white: '#ffffff',
      blue: blue[600],
      lightGray: '#6C6C6C',
    },
    button: {
      state: {
        save: '#008B43',
        refresh: blue[500],
        delete: red[700],
        print: '#9370DB',
        restore: '#cf1b1b',
      },
      //   호버는 main색상만 주면 알아서 되는건지 알아봐야함
      hover: {
        save: '#008B0003',
        refresh: '#2196F305',
        delete: '#D32F2F0A',
        print: '#7E5FC8',
        // restore: '#cf1b1b',  현재 초록색으로 되어 있음
      },
    },
    common: {
      black: '#000000',
      white: '#ffffff',
      green: green[700],
      scrollbar: '#007f3d',
      tableScrollbar: '#f1f1f1',
    },
    highlight: {
      yellow: yellow[800],
      darkGray: grey[800],
      blue: '#0056B3',
      lightGreen: green[50],
      lightGray: grey[50],
      lightBlue: '#e0f0ff',
    },

    // test: {
    //   1: '#2CA900',
    //   2: '#D32F2F',
    //   3: '#008B43',
    //   4: '#fff',
    //   5: '#E8F5E9',다른 공통되는 색 써도 되는지
    //   6: '#1E88E5',
    //   7: '#388E3C',
    //   8: '#000',
    //   9: '#000000',
    //   10: '#FFC107',
    //   11: '#FAFAFA', 다른 공통되는 색 써도 되는지
    //   12: '#e0f0ff',
    //   14: '#f1f1f1',
    //   15: '#0056B3',
    //   16: '#F9A825',
    //   17: '#424242',
    //   18: '#888',
    //   19: '#888888',
    //   20: '#4CAF50',
    //   21: '#f44336',
    //   22: '#fffdf5', 다른 공통되는 색 써도 되는지
    //   23: '#1976d2',
    //   24: '#2196F3',
    //   25: '#9370DB',
    //   26: '#D0DBD1', 마이페이지에서만 쓰이므로 제외
    //   27: '#cf1b1b',
    //   28: '#E6F7E0', 드로워에만 쓰이는데 꼭 이 색을 사용해야 하는지
    //   29: '#333333',
    //   30: '#6C6C6C',
    //   31: '#F7F7F7', 공지사항에만 쓰이는데 꼭 이 색을 사용해야 하는지 제외
    //   32: '#999', 텍스트색상 회색 사용중인데 다른 색상도 있어 필요 없을 것 같아 제외
    //   33: '#333',
    //   34: '#f0f0f0',
    //   35: '#E9F0F1', 마이페이지에서만 쓰이므로 제외
    //   36: '#00602E', 마이페이지에서만 쓰이므로 제외
    //   37: '#FFDE5A', 마이페이지에서만 쓰이므로 제외
    //   38: '#FFD839',마이페이지에서만 쓰이므로 제외
    //   39: '#D2E1E5', 마이페이지에서만 쓰이므로 제외
    //   40: '#249100', 모달안에 저장 버튼 색 다른 저장 버튼과 색이 같아야 하므로 제외
    //   41: '#7E5FC8',
    //   42: '#E4E8E9',
    //   43: '#007f3d',
    //   44: '#666666', ??????????????????
    //   45: '#128191',
    // },

    // mode: "dark",
    // background: {
    // 	default: "#090e23",
    // 	paper: "#090e23",
    // },
    // primary: {
    //   light: '#008b43',
    //   main: '#008b43',
    //   dark: '#00b557',
    //   contrastText: '#fff',
    // },
    // secondary: {
    //   light: '#63ccff',
    //   main: '#2196f3',
    //   dark: '#0069c0',
    //   contrastText: '#fff',
    // },
  },
});

export default theme;
